import samsungs1 from "../../assets/samsungStore/carouselImages/carousal2/samsungs1.png";
import samsungs2 from "../../assets/samsungStore/carouselImages/carousal2/awesome.png";
import samsungs3 from "../../assets/samsungStore/carouselImages/carousal2/samsungs3.png";
import samsungs4 from "../../assets/samsungStore/carouselImages/carousal2/samsungs4.png";

import samF56 from "../../assets/samsungStore/carouselImages/carousal3/samF56.png";
import samF16 from "../../assets/samsungStore/carouselImages/carousal3/samF16.png";

import samsTab10 from "../../assets/samsungStore/carouselImages/carousal4/tabs10.png";
import samsTab10fe from "../../assets/samsungStore/carouselImages/carousal4/tabs10fe.png";

import samflip1 from "../../assets/samsungStore/carouselImages/carousal5/samflip1.png";
import samflip2 from "../../assets/samsungStore/carouselImages/carousal5/samflip2.png";
import samflip3 from "../../assets/samsungStore/carouselImages/carousal5/samflip3.png";
import innerIconWaterResist from "../../assets/samsungStore/carouselImages/icons/innerIconWaterResist.png";
import snapdragon from "../../assets/samsungStore/carouselImages/icons/snapdragon-Photoroom.png";
import innerIcon3 from "../../assets/samsungStore/carouselImages/icons/innerIcons3.png";

import zFold7Main from "../../assets/samsungStore/carouselImages/carousal0/zfold7Main.png";
import zFlip7Main from "../../assets/samsungStore/carouselImages/carousal0/zflip7Main.png";
import zFlip7FeMain from "../../assets/samsungStore/carouselImages/carousal0/zflip7feMain.png";


export const promoSlides1 = [
  {
    id: 1,
    title: "The new Galaxy A56 5G",
    subtitle: "Slimmer design with a stylish twist.",
    image: samsungs1,
    footer: "Buy the Galaxy A56 on EMI today.",
    path: "/applestore/iphone-products-list/iphone-detail-page/galaxyASeries/2",
  },
  {
    id: 2,
    title: "The new Galaxy A36 5G",
    subtitle: "A mix of minimalism and durability.",
    image: samsungs2,
    footer: "Buy the Galaxy A36 on EMI today.",
    path: "/applestore/iphone-products-list/iphone-detail-page/galaxyASeries/3",
  },
  {
    id: 3,
    title: "Galaxy A26 5G",
    subtitle: "Slim. Shiny. Stylish.",
    image: samsungs3,
    footer: "Buy the Galaxy A26 on EMI today.",
    path: "/applestore/iphone-products-list/iphone-detail-page/galaxyASeries/4",
  },
  {
    id: 4,
    title: "Galaxy A16 5G",
    subtitle: "Go Limitless: Multi Cameras. Multple Possibilities.",
    image: samsungs4,
    footer: "Buy the Galaxy A16 on EMI today.",
    path: "/applestore/iphone-products-list/iphone-detail-page/galaxyASeries/1",
  },
];

export const promoSlides2 = [
  {
    id: 1,
    title: "The new Galaxy F56 5G",
    subtitle: "Classy design and fab colours.",
    image: samF56,
    footer: "Buy the Galaxy F56 on EMI today.",
    path: "/applestore/iphone-products-list/iphone-detail-page/galaxyFSeries/1",
  },
  {
    id: 2,
    title: "The new Galaxy F16 5G",
    subtitle: "Unstoppable Speed, Unmatched Style.",
    image: samF16,
    footer: "Buy the Galaxy F16 on EMI today.",
    path: "/applestore/iphone-products-list/iphone-detail-page/galaxyFSeries/2",
  },
];
export const promoSlides3 = [
  {
    id: 1,
    title: "Galaxy Tab S10 Series",
    subtitle: "Galaxy AI ✨ is here",
    image: samsTab10,
    footer: "Buy the Galaxy Tab on EMI today.",
    path: "/applestore/iphone-products-list/iphone-detail-page/galaxyTab/2",
  },
  {
    id: 2,
    title: "Galaxy Tab S10 FE+ Series",
    subtitle:
      "The perfect balance of power and play with Intelligent Galaxy Features.",
    image: samsTab10fe,
    footer: "Buy the Galaxy Tab on EMI today.",
    path: "/applestore/iphone-products-list/iphone-detail-page/galaxyTab/3",
  },
];

export const flipSeries = [
  {
    id: 1,
    image: zFold7Main,
    slideName: "firstSlide",
    title: "Galaxy Z Fold 7",
    priceStarts: "Starting at ₹1,74,999",
    description: "Ultra 200 MP camera, now on fold.",
    icons: [],
    path: "/applestore/iphone-products-list/iphone-detail-page/galaxyZSeries/1",
  },
  {
    id: 2,
    image: zFlip7Main,
    title: "Galaxy Z Flip 7",
    priceStarts: "Starting at ₹1,09,999",
    description: "50 MP camera for selfies",
    icons: [],
    path: "/applestore/iphone-products-list/iphone-detail-page/galaxyZSeries/2",
  },
  {
    id: 3,
    image: zFlip7FeMain,
    title: "Galaxy Z Flip 7 FE",
    priceStarts: "Starting at ₹89, 999",
    description: "Time to make it flip.",   
    path: "/applestore/iphone-products-list/iphone-detail-page/galaxyZSeries/3",
  },
];
export const flipData = [
  {
    id: 1,
    image: samflip1,
    slideName: "firstSlide",
    title: "Galaxy Z",
    description: "Explore the Fold. Flip.\nExperience the Future",
    icons: [],
    path: "",
  },
  {
    id: 2,
    image: samflip2,
    title: "Galaxy Z Fold 6",
    description: "Explore the Fold. Flip.\nExperience the Future",
    icons: [],
    path: "",
  },
  {
    id: 3,
    image: samflip3,
    title: "Galaxy Z Flip 6",
    description: "Explore the Fold. Flip.\nExperience the Future",
    icons: [
      {
        icons: innerIconWaterResist,
        description:
          "IP <strong>68 Water-resistance</strong> for those unexpected spills.",
      },
      {
        icons: snapdragon,
        description:
          "The <strong>fastest Snapdragon</strong> on a Galaxy Z Flip yet.",
      },
      {
        icons: innerIcon3,
        description:
          "<strong>50MP</strong>. The most powerful camera on <strong>Galaxy Z Flip</strong> now with AI",
      },
    ],
    path: "",
  },
];
